import BaseService from "@root/core/class/BaseService";
import { IPagination } from '../../Product/interfaces'

class SettlementService extends BaseService {

    public TotalInvoiceInfo = () => {   
        return this.get(`totalInvoiceInfo`);
    }

    public fetchData =({
        productName,
        page,
        fieldSearch,
        sort,
        fromDt,
        toDt,
        status,
    }: IPagination) =>{
            let data = [...Array(10)].map((item,index) => (
                {
                    ...item,...{
                    key: (page ?? 1)*10+index,
                    invoiceNo: "ABC" + ((page ?? 1 )*100 +index),
                    country: ["","USA","Franch","Singapore"][Math.ceil(Math.random() * 3)],
                    price: (Math.random()*100).toFixed(2),
                    state: ["","확인요청","결제대기","결제완료"][Math.ceil(Math.random() * 3)],
                    warehouse: ["","Old","New","Singapore"][Math.ceil(Math.random() * 3)],
                    UpdateDate: new Date(new Date().getTime() +  [0,1000,10000,3000][Math.ceil(Math.random() * 3)]).toISOString(),
                    }
                }
            ))
            return {data:data,meta:{totalPages:1,currentPage:1,totalItems:10}}
    }

    public getPaging = ({
        productName,
        page,
        fieldSearch,
        sort,
        fromDt,
        toDt,
        status
      }: IPagination) => {
        let url = "/settlements" + `?page=${page}&limit=10`;
        url = !!status ? (url += `&filter.status=${status}`) : url;
        url =
          productName !== "" &&
          productName !== null &&
          fieldSearch !== "" &&
          !!fieldSearch
            ? (url += `&filter.${fieldSearch}=${productName}`)
            : url;
        url = sort
          ? (url += `&sortBy=updated_at:DESC`)
          : (url += "&sortBy=updated_at:ASC");
        url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
        url = toDt ? (url += `&filter.to=${toDt}`) : url;
        return this.get(url);
      };

      //api export excel all 
    public exportExcel = ({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt,
        status
    }: IPagination) => {
        let url = `/settlements/export-all?`;
        // url = (!!productName &&
        //       !!fieldSearch) || !!sort || !!fromDt || !!toDt ? url + '?' : url;
        url = !!status ? (url += `&filter.status=${status}`) : url;
        url +=   ((!!productName  &&
                !!fieldSearch) ?`&filter.${productName}=${fieldSearch}`:'')
                + (!!fromDt ? `&filter.from=${fromDt}` : '')
                + (!!toDt ? `&filter.from=${fromDt}` : '')
                + (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC` );
        let urlUse = url.replace('?&','?')
        return this.get(
        urlUse,
        {},
        {
            responseType: "blob",
        }
        );
    };

    //api export excel follow array id
    public exportExcelById = (productId: number[]) => {
        let value = "ids=";
        productId.forEach((item: number) => {
        value = value + item + ",";
        });
        return this.get(
        `/settlements/export?${value.substring(
            0,
            value.length - 1
        )}`,
        {},
        {
            responseType: "blob",
        }
        );
    };

    public getDetail = (detailId : number) => {
        return this.get(`/settlements/detail/${detailId}`)
    }

    public getAmountInfo = () => {
        return this.get('/settlements/amountInfo')
    }

    // public getAmountInfo = ({
    //     productName,
    //     fieldSearch,
    //     sort,
    //     fromDt,
    //     toDt,
    //     status
    //   }: IPagination
    // ) => {
    //     let url = "/settlements/amountInfo?";
    //     url = !!status ? (url += `&filter.status=${status}`) : url;
    //     url =
    //       productName !== "" &&
    //       productName !== null &&
    //       fieldSearch !== "" &&
    //       !!fieldSearch
    //         ? (url += `&filter.${fieldSearch}=${productName}`)
    //         : url;
    //     url = sort
    //       ? (url += `&sortBy=updated_at:DESC`)
    //       : (url += "&sortBy=updated_at:ASC");
    //     url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
    //     url = toDt ? (url += `&filter.to=${toDt}`) : url;
    //     let urlUse = url.replace('?&','?')
    //     return this.get(urlUse)
    // }

    public CaptureOrder = (body: Record<string, any>) =>{
        return this.post('/settlements/captureOrderPayment', body);
    }

}
    

export default new SettlementService("/api/v1/seller",true)